import api from './api';

const authService = {
  /**
   * Admin login
   * @param {string} email
   * @param {string} password
   * @returns {Promise<{token: string, user: object}>}
   */
  login: async (email: string, password: string) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.success && response.data) {
      // Store token and user data
      localStorage.setItem('staff_token', response.data.token);
      localStorage.setItem('staff_user', JSON.stringify(response.data.user));
      return response.data;
    }
    throw new Error(response.error?.message || 'Login failed');
  },

  /**
   * Logout
   */
  logout: () => {
    localStorage.removeItem('staff_token');
    localStorage.removeItem('staff_user');
  },

  /**
   * Get current user
   * @returns {Promise<object>}
   */
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    if (response.success && response.data) {
      localStorage.setItem('staff_user', JSON.stringify(response.data.user));
      return response.data.user;
    }
    throw new Error(response.error?.message || 'Failed to fetch user data');
  },

  /**
   * Check if user is logged in
   * @returns {boolean}
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('staff_token');
  },

  /**
   * Get stored user data
   * @returns {object|null}
   */
  getStoredUser: () => {
    const userStr = localStorage.getItem('staff_user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
